import { render, staticRenderFns } from "./user-withdrawal-repair-dialog.vue?vue&type=template&id=49478c5c&scoped=true&"
import script from "./user-withdrawal-repair-dialog.vue?vue&type=script&lang=js&"
export * from "./user-withdrawal-repair-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49478c5c",
  null
  
)

export default component.exports